import { LoginTextFieldProps } from './types';
import * as S from './styles';

const LoginTextField = (props: LoginTextFieldProps): JSX.Element => <S.Container {...props} />;

export default LoginTextField;
